var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Card, Grid, Typography } from '@material-ui/core';
import { EmailSignUpForm } from './EmailSignUpForm';
import { useEmbeddedSignUpCardStyles, useEmbeddedSignUpStyles } from './EmbeddedSignUpTypes';
import { SocialSignUpForm } from './SocialSignUpForm';
export function EmbeddedSignUp(props) {
    var redirectTo = props.redirectTo;
    var _a = __read(useState(false), 2), isEmailFormOpen = _a[0], setIsEmailFormOpen = _a[1];
    var cardClasses = useEmbeddedSignUpCardStyles();
    var classes = useEmbeddedSignUpStyles();
    return (React.createElement(Grid, { container: true },
        React.createElement(Card, { classes: cardClasses },
            React.createElement(Grid, { className: classes.form },
                React.createElement(Typography, { variant: "h1", className: classes.marketing }, "Explore your creativity"),
                React.createElement(Typography, { variant: "h2", className: classes.subTitle }, "Get started for free"),
                isEmailFormOpen ? (React.createElement(EmailSignUpForm, { redirectTo: redirectTo, isModal: false, hideLogin: true })) : (React.createElement(SocialSignUpForm, { redirectTo: redirectTo, switchToEmailSignUp: setIsEmailFormOpen, hideLogin: true }))))));
}
//# sourceMappingURL=EmbeddedSignUp.js.map